export const numberIsOdd = (num) => num % 2 !== 0;
